module.exports = __webpack_public_path__ + "media/images/products/ob22/ob22-1-200x200-50e573926f0226fe0d934f4229951571.png";